function formatMoney(amount) {
  return "$" + Number(amount).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
// Function to get a cookie by name
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

// Function to parse JSON safely from a cookie
function getJSONCookie(name) {
  const cookieValue = getCookie(name);
  if (!cookieValue) return null;
  try {
    return JSON.parse(decodeURIComponent(cookieValue));
  } catch (e) {
    console.error("Failed to parse cookie JSON:", e);
    return null;
  }
}

function getCookiePostCode(){
  const shopifyCookie = getCookie('regional_postcode');
  const regional_postcode = getJSONCookie('regional_postcode');
  if (!regional_postcode) {
    console.warn("Regional postcode cookie not found!");
    return;
  }
  return regional_postcode.postcode;
}


function getCookieZoneCode(){
  const shopifyCookie = getCookie('regional_postcode');
  const regional_postcode = getJSONCookie('regional_postcode');
  if (!regional_postcode) {
    console.warn("Regional zoneId cookie not found!");
    return;
  }
  return regional_postcode.zoneName;
} 

function initGetZone(){
      var postcode = getCookiePostCode();
      var zonecode = getCookieZoneCode();
      const zone = zonecode?.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '').trim();
      if (!zone) return;

  document.querySelectorAll('.grid-price-wrapper').forEach(wrapper => {

    const allZones = wrapper.querySelectorAll('.zone-price');
    allZones.forEach(el => el.style.display = 'none');

    // try to find zone
    let active = wrapper.querySelector(`[data-zone="${zone}"]`);

    // ❗ fallback if zone not found
    if (!active) {
      active = wrapper.querySelector('[data-zone="default"]');
    }

    if (active) {
      active.style.display = 'flex';
    }
  });

  updateSubtotal(zone)
}

function updateSubtotal(zone){
  var compare_subtotal = 0;
  var subtotal = 0;

  var subtotal_element = document.querySelector('[data-subtotal]')
  var subtotal_compare_element = document.querySelector('[data-subtotal-compare]')

  document.querySelectorAll('.cart-drawer__product_card').forEach(wrapper => {
    // try to find zone
    let active = wrapper.querySelector(`[data-zone="${zone}"]`);

    // ❗ fallback if zone not found
    if (!active) {
      active = wrapper.querySelector('[data-zone="default"]');
    }

    if (active.querySelector('[item-compare-price]')){
      compare_subtotal += parseFloat(active.querySelector('[item-compare-price]')?.getAttribute('item-compare-price'));
    }
    subtotal += parseFloat(active.querySelector('[item-price]').getAttribute('item-price'));
  });


  subtotal_element.textContent = formatMoney(subtotal);
  if (subtotal_compare_element){
    subtotal_compare_element.textContent = formatMoney(compare_subtotal);
  }
}


function waitForRecommendationsAndRun() {
  const observer = new MutationObserver(() => {
    const section = document.querySelector(".product-recommendations");
    if (section && section.querySelector("product-card[data-sku]")) {
      initGetZone();
      observer.disconnect(); 
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}






// Run when page is fully loaded
window.addEventListener('DOMContentLoaded', initGetZone);
document.addEventListener('paginate', function () {
  initGetZone();
});


document.addEventListener("DOMContentLoaded", function () {
   if (document.querySelector(".template-product")) {
      waitForRecommendationsAndRun();
   }
});

// Update price when search
(function () {
  const SEARCH_URL = "/search/suggest.json";

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = args[0];

    const response = await originalFetch.apply(this, args);

    if (typeof url === "string" && url.includes(SEARCH_URL)) {
      try {
        const cloned = response.clone();
        const data = await cloned.json();
        initGetZone();
      } catch (e) {
        console.error("Error parsing response:", e);
      }
    }

    return response;
  };

  // XHR fallback
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._url = url;
    return originalOpen.apply(this, [method, url, ...rest]);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener("load", function () {
      if (this._url && this._url.includes(SEARCH_URL)) {
        try {
          const data = JSON.parse(this.responseText);
          initGetZone();
        } catch (e) {
          console.error("XHR parse error:", e);
        }
      }
    });

    return originalSend.apply(this, args);
  };

})();



// // Custom BUY NOW button ( buy now)
// document.addEventListener("DOMContentLoaded", function () {
//   const buyNowBtn = document.querySelector(".dynamic-section-button-buy-it-now"); // Replace class name

//   if (!buyNowBtn) return;

//   buyNowBtn.addEventListener("click", async function (e) {
//     e.preventDefault();

//     // Disable button
//     buyNowBtn.setAttribute("disabled", true);

//     // Hide text
//     const textEl = buyNowBtn.querySelector("[data-buy-it-now]");
//     if (textEl) textEl.style.display = "none";

//     // Show loader
//     const loader = buyNowBtn.querySelector("svg");
//     if (loader) loader.classList.remove("hidden");

//     // Get form
//     const form = buyNowBtn.closest("form");
//     if (!form) return;

//     const formData = new FormData(form);

//     // Get Cookie Function
//     function getCookie(name) {
//       const match = document.cookie.match(
//         new RegExp("(^|; )" + name + "=([^;]*)")
//       );
//       return match ? decodeURIComponent(match[2]) : null;
//     }

//     try {
//       // Add To Cart
//       const response = await fetch("/cart/add.js", {
//         method: "POST",
//         body: formData,
//         headers: {
//           Accept: "application/json"
//         }
//       });

//       if (!response.ok) throw new Error("Cart Error");

//       // Get cookie raw value
//       const rawCookie = getCookie("regional_postcode");

//       let checkoutUrl = "/checkout";

//       // If cookie exists
//       if (rawCookie) {
//         try {
//           const cookieData = JSON.parse(rawCookie);

//           // Get postcode from JSON cookie
//           if (cookieData.postcode) {
//             checkoutUrl =
//               "/checkout?checkout%5Bshipping_address%5D%5Bzip%5D=" +
//               encodeURIComponent(cookieData.postcode);
//           }
//         } catch (err) {
//           console.log("Invalid JSON Cookie");
//         }
//       }

//       // Redirect
//       window.location.href = checkoutUrl;

//     } catch (error) {
//       console.error(error);

//       // Reset button
//       buyNowBtn.removeAttribute("disabled");

//       if (textEl) textEl.style.display = "";
//       if (loader) loader.classList.add("hidden");
//     }
//   });
// });
// Custom BUY NOW button (buy now)
document.addEventListener("DOMContentLoaded", function () {
  const buyNowBtn = document.querySelector(
    ".dynamic-section-button-buy-it-now"
  );

  if (!buyNowBtn) return;

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^|; )" + name + "=([^;]*)")
    );
    return match ? decodeURIComponent(match[2]) : null;
  }

  async function saveCartAttributes(data) {
    try {
      // STEP 1: REMOVE OLD WRONG KEY FIRST (IMPORTANT FIX)
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            Postcode: "", // 🔥 delete old key
          },
        }),
      });

      // STEP 2: SET CLEAN SINGLE SOURCE ATTRIBUTES
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            postcode: data.postcode || "",
            city: data.city || "",
            state: data.state || "",
            zoneId: data.zoneId || "",
            zoneName: data.zoneName || "",
            RegionalPricing: data.RegionalPricing || "",
            ClubMember: data.ClubMember || "",
          },
        }),
      });
    } catch (err) {
      console.error("Cart attribute update failed:", err);
    }
  }

  buyNowBtn.addEventListener("click", async function (e) {
    e.preventDefault();

    buyNowBtn.setAttribute("disabled", true);

    const textEl = buyNowBtn.querySelector("[data-buy-it-now]");
    if (textEl) textEl.style.display = "none";

    const loader = buyNowBtn.querySelector("svg");
    if (loader) loader.classList.remove("hidden");

    const form = buyNowBtn.closest("form");
    if (!form) return;

    const formData = new FormData(form);

    try {
      // STEP 1: Add product to cart
      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) throw new Error("Cart Error");

      // STEP 2: Read cookie
      const rawCookie = getCookie("regional_postcode");

      let cookieData = null;

      if (rawCookie) {
        try {
          cookieData = JSON.parse(rawCookie);
        } catch (err) {
          console.error("Invalid cookie JSON:", err);
        }
      }

      console.log("Cookie Data:", cookieData);

      // STEP 3: FIX ATTRIBUTES (REMOVE DUPLICATE ISSUE)
      if (cookieData) {
        await saveCartAttributes(cookieData);
      }

      // STEP 4: VERIFY CLEAN CART
      fetch("/cart.js")
        .then((r) => r.json())
        .then((data) => {
          console.log("CLEAN CART ATTRIBUTES:", data.attributes);
        });

      // STEP 5: REDIRECT TO CHECKOUT
      window.location.href = "/checkout";
    } catch (error) {
      console.error(error);

      buyNowBtn.removeAttribute("disabled");

      if (textEl) textEl.style.display = "";

      if (loader) loader.classList.add("hidden");
    }
  });
});



// new js

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// zone base home slider
// document.addEventListener("DOMContentLoaded", function () {

//   function filterZoneSlides() {
//     let zonecode = getCookieZoneCode();

//     // "Zone 1" → "Zone_1"
//     let activeZone = zonecode
//       ? zonecode.trim().replace(/\s+/g, "_")
//       : "Zone_1";

//     const swiperWrapper = document.querySelector(".swiper-wrapper");
//     if (!swiperWrapper) return;

//     const allSlides = swiperWrapper.querySelectorAll(
//       ".homepage-sections--slideshow-wrapper[data-zone]"
//     );

//     if (!allSlides.length) return;

//     let matchedSlides = [];

//     allSlides.forEach(function (slide) {
//       const slideZone = slide.getAttribute("data-zone")?.trim();

//       if (slideZone === activeZone) {
//         matchedSlides.push(slide);
//       }
//     });

//     // Agar match na mile to Zone_1 fallback
//     if (!matchedSlides.length) {
//       allSlides.forEach(function (slide) {
//         const slideZone = slide.getAttribute("data-zone")?.trim();

//         if (slideZone === "Zone_1") {
//           matchedSlides.push(slide);
//         }
//       });
//     }

//     // Sab remove karo jo required nahi
//     allSlides.forEach(function (slide) {
//       if (!matchedSlides.includes(slide)) {
//         slide.remove();
//       }
//     });
//   }

//   // Swiper init hone se pehle run karo
//   filterZoneSlides();

// });

// document.addEventListener("DOMContentLoaded", function () {

//   function updateZoneSlidesAndPagination() {
//     let zonecode = getCookieZoneCode();

//     // Example: "Zone 1" → "Zone_1"
//     let activeZone = zonecode
//       ? zonecode.trim().replace(/\s+/g, "_")
//       : "Zone_1";

//     const swiperWrapper = document.querySelector(".swiper-wrapper");
//     const sliderSection = document.querySelector(".slideshow-slider-container");

//     if (!swiperWrapper || !sliderSection) return;

//     const allSlides = swiperWrapper.querySelectorAll(
//       ".homepage-sections--slideshow-wrapper[data-zone]"
//     );

//     if (!allSlides.length) return;

//     let matchedSlides = [];

//     // matching zone collect karo
//     allSlides.forEach(function (slide) {
//       const slideZone = slide.getAttribute("data-zone")?.trim();

//       if (slideZone === activeZone) {
//         matchedSlides.push(slide);
//       }
//     });

//     // fallback → Zone_1
//     if (!matchedSlides.length) {
//       allSlides.forEach(function (slide) {
//         const slideZone = slide.getAttribute("data-zone")?.trim();

//         if (slideZone === "Zone_1") {
//           matchedSlides.push(slide);
//         }
//       });
//     }

//     // unwanted slides remove karo
//     allSlides.forEach(function (slide) {
//       if (!matchedSlides.includes(slide)) {
//         slide.remove();
//       }
//     });

//     // pagination bars count dynamically set karo
//     sliderSection.style.setProperty(
//       "--zone-slide-count",
//       matchedSlides.length || 1
//     );

//     // swiper refresh
//     const swiperEl = document.querySelector(".slideshow-slider-container .swiper");

//     if (swiperEl && swiperEl.swiper) {
//       swiperEl.swiper.update();
//     }
//   }

//   updateZoneSlidesAndPagination();

// });
document.addEventListener("DOMContentLoaded", function () {

  function filterZoneSlides() {
    // Cookie se selected zone lo
    let zonecode = getCookieZoneCode();

    console.log("Cookie Zone Raw:", zonecode);

    // Example:
    // "Zone 1" -> "Zone_1"
    let activeZone = zonecode
      ? zonecode.trim().replace(/\s+/g, "_")
      : null;

    console.log("Formatted Zone:", activeZone);

    const swiperWrapper = document.querySelector(".swiper-wrapper");
    const sliderSection = document.querySelector(".slideshow-slider-container");

    if (!swiperWrapper || !sliderSection) return;

    const allSlides = swiperWrapper.querySelectorAll(
      ".homepage-sections--slideshow-wrapper[data-zone]"
    );

    if (!allSlides.length) return;

    let matchedSlides = [];

    /*
      Logic:

      1. Agar cookie se zone mila (Zone_1 to Zone_4)
         → sirf us zone wali slides show hongi

      2. Agar cookie bilkul nahi mili (customer ka koi zone nahi hai)
         → outdoor slides check karo
         → agar outdoor slides available hain, sirf wo show hongi

      3. Agar outdoor bhi na mile (ya cookie mili but koi slide match na hui)
         → default wali slides show hongi
    */

    // STEP 1 → Zone match check (Zone_1 - Zone_4)
    if (activeZone) {
      allSlides.forEach(function (slide) {
        const slideZone = slide.getAttribute("data-zone")?.trim();

        if (slideZone === activeZone) {
          matchedSlides.push(slide);
        }
      });
    }

    // STEP 2 → customer ke paas koi zone hi nahi hai → outdoor try karo
    if (matchedSlides.length === 0 && !activeZone) {
      console.log("No zone from customer, checking outdoor slides");

      let outdoorSlides = [];

      allSlides.forEach(function (slide) {
        const slideZone = slide.getAttribute("data-zone")?.trim();

        if (slideZone === "outdoor") {
          outdoorSlides.push(slide);
        }
      });

      if (outdoorSlides.length > 0) {
        matchedSlides = outdoorSlides;
      }
    }

    // STEP 3 → fallback to default
    // (covers: no outdoor slides configured, or cookie had a zone that matched nothing)
    if (matchedSlides.length === 0) {
      console.log("Showing default slides");

      allSlides.forEach(function (slide) {
        const slideZone = slide.getAttribute("data-zone")?.trim();

        if (slideZone === "default") {
          matchedSlides.push(slide);
        }
      });
    }

    // STEP 4 → remove all non-matching slides
    allSlides.forEach(function (slide) {
      if (!matchedSlides.includes(slide)) {
        slide.remove();
      }
    });

    // Dynamic pagination bars count
    sliderSection.style.setProperty(
      "--zone-slide-count",
      matchedSlides.length || 1
    );

    // Swiper refresh
    const swiperEl = document.querySelector(".slideshow-slider-container .swiper");

    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.update();
    }
  }

  // On page load
  filterZoneSlides();

});